/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketMetricsViewModel } from '../../models/support-ticket-metrics-view-model';

export interface GetTicketMetrics$Params {
}

export function GetTicketMetrics(http: HttpClient, rootUrl: string, params?: GetTicketMetrics$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketMetricsViewModel>> {
  const rb = new RequestBuilder(rootUrl, GetTicketMetrics.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupportTicketMetricsViewModel>;
    })
  );
}

GetTicketMetrics.PATH = '/api/Tickets/GetTicketMetrics';
